/* eslint-disable*/
import { v1 as uuidv1 } from 'uuid';
import qs from 'qs';
import HmacSHA1 from 'crypto-js/hmac-sha1';
import Base64 from 'crypto-js/enc-base64';

const REQUEST_BODY = 'request_body';
const APPLICATION_FORM = 'application/x-www-form-urlencoded';

/**
 * 字符比较方法.
 * @param {string} pre 当前字符.
 * @param {string} next 下一个字符.
 * @return {int} 两个字符的比较结果.
 */
function alphabeticalSort(pre, next) {
  return pre.localeCompare(next, 'kf', { caseFirst: 'upper' });
}
function fixKey(obj) {
  let newObj = {};
  for (var key in obj) {
    var newKey = key.toLowerCase();
    newObj[newKey] = obj[key];
  }
  return newObj;
}
/**
 * 获取签名方法.
 * @param {object} parameters 获取签名的参数.
 * @param {string} accessKeySecret 获取签名的密钥.
 * @return {string} 签名.
 */
// function generateSignature(parameters, accessKeySecret, requestMethod) {
//   let parametersNew;
//   if (requestMethod == 'GET') {
//     parametersNew = fixKey(parameters);
//   } else {
//     parametersNew = parameters;
//   }
//   const sortedParameters = qs.stringify(parametersNew || {}, {
//     sort: alphabeticalSort,
//     parameterLimit: 1000,
//     encode: false
//   });
//   const key = accessKeySecret + '&';
//   const h = HmacSHA1(sortedParameters, key);
//   return Base64.stringify(h).trim();
// }

function generateSignature(parameters, accessKeySecret) {
  const sortedParameters = qs.stringify(parameters || {}, {
    sort: alphabeticalSort,
    parameterLimit: 1000,
    encode: false
  });
  const key = accessKeySecret + '&';
  const h = HmacSHA1(sortedParameters, key);
  return Base64.stringify(h).trim();
}

export const getHttpSignature = (
  urlParams,
  bodyParams,
  requestMethod,
  contentType,
  accessKeySecret
) => {
  const signatureNonce = uuidv1();
  const signParam = {
    signature_nonce: signatureNonce
  };
  Object.keys(urlParams).forEach((key) => {
    signParam[key] = urlParams[key];
  });
  const signature = generateSignature(
    signParam,
    accessKeySecret,
    requestMethod
  );
  return {
    signature,
    signatureNonce
  };
};

export const getWsSignature = (urlParams, accessKeySecret) => {
  const signatureNonce = uuidv1();
  const signParam = {
    signature_nonce: signatureNonce
  };
  Object.keys(urlParams).forEach((key) => {
    signParam[key] = urlParams[key];
  });
  const signature = generateSignature(signParam, accessKeySecret);
  return {
    signature,
    signatureNonce
  };
};
